<template>
  <section>
    <div class="content_bg">
      <div class="content">
        <Caption label="Data Play" />
        <ul>
          <li>
            <SectionTechItem 
              :image="'tech_icon_firebase.png'"
              :record ="{
                text1:'Firebase',
                text2:'기본적으로 Firebase를 탑재합니다',
              }"/>
          </li>
          <li>
            <SectionTechItem :image="'tech_icon_ga.png'"
              :record ="{
                text1:'Google Analytics',
                text2:'GA로 데이터를 수집하고 고객 행동을 알 수 있습니다',
              }"/>
          </li>
          
        </ul>

        <div class="desc">
          리텐션, 데이터 플레이란 말 들어보셨나요?<br/>
          마케팅을 해서 다운로드 수는 늘었는데 고객이 만족하는지, 
          다시 방문하는지, 아직도 느낌으로 판단하시나요?<br/>
          먼데이리스는 Firebase와 GA를 이용하여, 성장 방향에 대한 답을 찾아드립니다
        </div>
      </div>
    </div>
  </section>
</template>
  
  <script>
import Caption from "./Caption.vue";
import SectionTechItem from "./SectionTechItem.vue";
export default {
  components: {
    Caption,
    SectionTechItem,
  },
  data() {
    return {};
  },
};
</script>
  
<style scoped>
.content_bg {
  display: inline-block;
  text-align: center;
  width: 100vw;
  height: fit-content;
  background-color: #ffffff;
  position: relative;
  overflow: hidden;
}

.content {
  display: inline-block;
  text-align: center;
  width: 100vw;
  height: 100%;
  max-width: 1140px;
  padding: 100px 20px 100px 20px;
}

.title_box {
  width: 272px;
}
ul {
  margin-bottom: 80px;
  width: 100%;
  justify-content: space-between;
  list-style-type: none;
  display: flex;
  flex-wrap: wrap;
  padding: 0;
}

ul li {
  margin-top: 50px;
  display: inline-block;
}

.desc {
  font-weight: 300;
  font-size: 24px;
  color: #000000;
}

@media screen and (max-width: 1440px) {
  .content_bg {
    display: inline-block;
    text-align: center;
    width: 100vw;
    height: fit-content;
    background-color: #ffffff;
    position: relative;
    overflow: hidden;
  }

  .content {
    display: inline-block;
    text-align: center;
    width: 100vw;
    height: 100%;
    max-width: 1140px;
    padding: 100px 20px 100px 20px;
  }

  .title_box {
    width: 272px;
  }
  ul {
    margin-bottom: 80px;
    width: 100%;
    list-style-type: none;
    display: block;
    text-align: center;
  }

  ul li {
    margin-top: 50px;
    width: fit-content;
    display: block;
    text-align: center;
  }
}
</style>
  